import React, { useState, useEffect, useRef, useMemo } from "react";
import Select from "react-select";
import styled from "styled-components";
import Text from "../../../../../components/atoms/Text";
import { isDesktop } from "react-device-detect";
import CustomModal from "../../../../../containers/customModal/customModal";
import Cross from "../../../../../components/molecules/BottomDrawer/assets/cross.svg";
import BottomDrawer from "../../../../../components/molecules/BottomDrawer/BottomDrawer";
import { PrimaryButton } from "../../../../../theme/globalStyleSheet";
import {
  device,
  isDesktopDevice,
} from "../../../../../commons/util/helperFunctions";
import fileUploadConfig from "../../HelpAndSupport/config/fileUploadConfig";
import config, { FRESH_DESK_API_KEY } from "../../../../../commons/config";
import callAPI from "../../../../../commons/callAPI";
import PushAlert from "../../../../../components/atoms/pushAlert";
import VideoIcon from "../../HelpAndSupport/assets/videoIcon.png";
import Util from "../../../../../commons/util/util";
import FileInput from "../../HelpAndSupport/components/fileInput";
import { getLocalStorage } from "../../../../../util/storageUtil";
import ButtonWithLoading from "components/atoms/ButtonWithLoading";
import { RaiseIssueTitle } from "../config/config";
import { colors } from "theme/colors";
import { useConfig } from "context/configContext";
import { getAppConfig } from "commons/util/appConfigHelper";
import ConfirmationMailIcon from "../assets/confirmationMail.svg";
import base64 from "react-native-base64";

const ReportIssueModal = (props) => {
  const sheetRef = useRef();
  const galleryImagesRef = useRef([]);
  const { locationCode } = useConfig();
  const imageExt = useMemo(() => fileUploadConfig.image, []);
  const maxImageSize = useMemo(() => fileUploadConfig.maxImageSize, []);
  const maxImageDimensions = useMemo(
    () => fileUploadConfig.maxImageDimensions,
    []
  );
  const [email, setEmail] = useState("");
  const [userRole, setUserRole] = useState([]);
  const [ticketTitle, setTicketTitle] = useState("");
  const [ticketDesc, setTicketDesc] = useState("");
  const [galleryImages, setGalleryImages] = useState();
  const [galleryImageList, setGalleryImageList] = useState([]);
  const [galleryImageNameList, setGalleryImageNameList] = useState([]);
  const [originalGalleryImageList, setOriginalGalleryImageList] = useState([]);
  const [variantImageSizeList, setVariantImageSizeList] = useState([]);
  const [duplicateGalleryImages, setDuplicateGalleryImages] = useState([]);
  const [deleteGalleryImage, setDeleteGalleryImage] = useState([]);
  const [submitIsLoading, setSubmitIsLoading] = useState(false);
  const [titleOptions, setTitleOptions] = useState([]);
  const [selectedTitle, setSelectedTitle] = useState();
  const [selectedStoreId, setSelectedStoreId] = useState({});
  const [subject, setSubject] = useState("");
  const [urgency, setUrgency] = useState(null);
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const urgencyList = [
    { label: "Low", value: 1 },
    { label: "Medium", value: 2 },
    { label: "High", value: 3 },
    { label: "Urgent", value: 4 },
  ];

  const customStyles = {
    control: (base) => ({
      ...base,
      background: "#ffffff",
      borderColor: "#25325a",
      padding: "2px",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#25325a",
      fontSize: "14px",
      fontWeight: "600",
    }),
  };

  useEffect(() => {
    const user = getLocalStorage("userData");
    if (user?.data?.email) {
      setEmail(atob(user?.data?.email));
    }
    if (user?.data?.roles) {
      setUserRole(user?.data?.roles);
    }
    getTitleOptions();
  }, []);

  const getTitleOptions = () => {
    let titles = RaiseIssueTitle[props?.domain];
    if (titles) {
      titles = titles?.concat(RaiseIssueTitle["Common"]);
    } else {
      titles = RaiseIssueTitle["Common"];
    }
    setTitleOptions(titles || []);
  };

  const closeModal = () => {
    document.body.style.overflow = "auto";
    const snapTo = (i) => sheetRef.current?.snapTo(i);
    snapTo(1);
    setShowConfirmation(false);
  };

  const IndicatorSeparator = () => {
    return <></>;
  };

  const handleGalleryImages = async (e) => {
    for (let index = 0; index < e.target.files.length; index++) {
      const file = e.target.files[index];
      const fileSize = file.size / 1000;
      try {
        if (
          fileSize < maxImageSize * 1000 &&
          e.target.files.length <= maxImageDimensions.image.limit &&
          galleryImageList.length < maxImageDimensions.image.limit
        ) {
          if (!galleryImageNameList.includes(file.name)) {
            setGalleryImageNameList((oldArray) => [...oldArray, file.name]);
            setGalleryImageList((oldArray) => [...oldArray, file]);
            setVariantImageSizeList((oldArray) => [...oldArray, fileSize]);
          } else {
            setDuplicateGalleryImages((o) => [...o, file.name]);
            PushAlert.error(
              'Duplicate image "' + file.name + '"is not allowed'
            );
          }
        } else {
          if (fileSize > maxImageSize * 1000)
            PushAlert.error(
              `${file.name} size is greater than ${maxImageSize}MB`
            );
          if (
            e.target.files.length > maxImageDimensions.image.limit ||
            galleryImageList.length >= maxImageDimensions.image.limit
          ) {
            PushAlert.error(
              `You are only allowed to upload ${maxImageDimensions.image.limit} files`
            );
            break;
          }
        }
      } catch (e) {
        console.log(e);
      }
    }
  };

  const removeGalleryImage = (i) => {
    const imageName = [...galleryImageNameList].splice(i, 1)[0];
    const imageSize = [...variantImageSizeList].splice(i, 1)[0];

    if (!originalGalleryImageList.includes(imageName)) {
      const images = Array.from(galleryImages).filter(
        (img) => img.name !== imageName
      );
      setGalleryImages(images);
      setGalleryImageList((oldArray) =>
        oldArray.filter((f) => f.name !== imageName)
      );
      setVariantImageSizeList((oldArray) =>
        oldArray.filter((f) => f.name !== imageSize)
      );
    } else {
      let deleteGalleryClone = [...deleteGalleryImage];
      deleteGalleryClone.push(imageName);
      setDeleteGalleryImage(deleteGalleryClone);
      setOriginalGalleryImageList(
        [...originalGalleryImageList].filter((img, index) => index !== i)
      );
    }
    setGalleryImageNameList(
      [...galleryImageNameList].filter((img, index) => index !== i)
    );
    setVariantImageSizeList(
      [...variantImageSizeList].filter((img, index) => index !== i)
    );
  };

  const isSubmitDisabled = () => {
    return (
      email === "" ||
      subject == "" ||
      description === "" ||
      urgency === null || urgency === undefined ||
      (urgency && Object.keys(urgency).length === 0)
    );
  };

  const clearHandler = () => {
    setSubject("");
    setDescription("");
    setUrgency(null);
    const user = getLocalStorage("userData");
    if (user?.data?.email) {
      setEmail(atob(user?.data?.email));
    } else {
      setEmail("");
    }
  };

  const handleCreateTicket = async () => {
    try {
      if (!Util.isEmailValid(email)) {
        PushAlert.error("Please enter a valid email id");
        return;
      }

      setSubmitIsLoading(true);
      const cc_emails = getAppConfig("FRESH_DESK_CC_EMAILS");
      const formData = new FormData();
      formData.append("email", email);
      formData.append("subject", `${locationCode} | ${subject}`);
      formData.append("description", description);
      formData.append("status", 2);
      formData.append("type", "Incident");
      formData.append("priority", urgency?.value);
      const ccEmails = [cc_emails];
      ccEmails.forEach((email) => {
        formData.append("cc_emails[]", email);
      });

      const apiURL = config.api.helpAndSupport.createTicket;

      const headers = {
        Authorization: `Basic ${base64.encode(FRESH_DESK_API_KEY)}`,
      };

      const response = await fetch(apiURL, {
        method: "POST",
        headers: headers,
        body: formData,
      });

      const regResponse = await response.json();

      if (response.status === 201) {
       setShowConfirmation(true);
       clearHandler();
      } else {
        PushAlert.error("Failed to create ticket. Please try again later.");
      }
    } catch (e) {
      console.error("Ticket creation failed:", e);
      PushAlert.error("Failed to create ticket. Please try again later.");
    } finally {
      setSubmitIsLoading(false);
    }
  };

  const handleUrgencyHandler = (e) => {
    const urgencyData = urgencyList?.find((item) => item?.value === e?.value);
    setUrgency({ label: urgencyData?.label, value: e?.value });
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const confirmationPopupRender = () => {
    return (
      <ConfirmationContainer>
        <TitleWrapper>
          <ConfirmationTitle>
            <Text type="medium">Your ticket has successfully been raised!</Text>
          </ConfirmationTitle>
          <ConfirmationSubTitle>
            <Text type="medium">
              You should’ve received an email with the details. Please check
              your inbox.
            </Text>
          </ConfirmationSubTitle>
          <ConfirmationMailImage src={ConfirmationMailIcon} />
          <ButtonWithLoading
            style={{
              width: isDesktopDevice() ? "150px" : "100%",
            }}
            onClick={closeModal}
            buttonLabel="Got It"
          />
        </TitleWrapper>
      </ConfirmationContainer>
    );
  };

  const confirmationPopup = () => {
    if (isDesktopDevice()) {
      return (
        <CustomModal
          isOpen={showConfirmation}
          boxStyle={{ maxWidth: "620px" }}
          modalStyle={{ zIndex: 999999 }}
        >
          <ModalContainer>
            <ModalContentContainer>
              {confirmationPopupRender()}
            </ModalContentContainer>
          </ModalContainer>
        </CustomModal>
      );
    } else {
      return (
        <BottomDrawer
          sheetRef={sheetRef}
          isOpen={showConfirmation}
          setIsOpen={setShowConfirmation}
          style={{
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#fff",
            borderRadius: "8px 8px 0px 0px",
          }}
          snapPoints={[1, 0]}
          initialSnap={0}
          disableDrag
          hideHeader={true}
          handleClose={closeModal}
        >
          <DrawerContainer>
            <DrawerContentContainer>
              {confirmationPopupRender()}
            </DrawerContentContainer>
          </DrawerContainer>
        </BottomDrawer>
      );
    }
  };
  return (
    <>
      <Wrapper>
        <ContentContainer>
          <Title>
            <Text type="extra-bold">Submit the ticket</Text>
          </Title>
          <FormContainer>
            <Row>
              <Label>Email *</Label>
              <CustomTextField
                value={email}
                onChange={(e) => setEmail(e?.target?.value)}
                placeholder={"Email"}
                type="text"
                mandatory={true}
                disabled={false}
                style={{ flex: "1", backgroundColor: "#fff", fontFamily: colors?.font?.primary}}
              />
            </Row>
            <Row>
              <Label>Subject *</Label>
              <CustomTextField
                value={subject}
                onChange={(e) => setSubject(e?.target?.value)}
                type="text"
                placeholder={"Subject"}
                mandatory={true}
                disabled={false}
                style={{ flex: "1", backgroundColor: "#fff", fontFamily: colors?.font?.primary}}
              />
            </Row>
            <Row>
              <Label>Urgency *</Label>
              <SelectionWrapper style={{ display: 'flex', flex: 1 }}>
                <Select
                  isSearchable={true}
                  value={urgency}
                  onChange={(e) => handleUrgencyHandler(e)}
                  placeholder="Select Urgency"
                  options={urgencyList}
                  components={{
                    IndicatorSeparator,
                  }}
                  styles={{
                    container: (base) => ({
                      ...base,
                      width: "100%",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      fontSize: "16px",
                      fontWeight: "400",
                      color: colors?.text?.black200,
                      paddingLeft: "20px",
                      fontFamily: colors?.font?.primary,
                      cursor: "pointer",
                    }),
                    control: (base) => ({
                      ...base,
                      width: "100%",
                      minWidth: "100%",
                      height: "36px",
                      minHeight: "36px",
                      borderRadius: "6px",
                    }),
                    menu: (base) => ({
                      ...base,
                      boxShadow: "none",
                      borderRadius: "8px",
                      marginTop: "5px",
                      marginBottom: "8px",
                      maxHeight: "36px",
                    }),
                    menuList: (base) => ({
                      ...base,
                      maxHeight: "150px",
                    }),
                    option: (base) => ({
                      ...base,
                      border: `1px solid #e9e9e9`,
                      display: "flex",
                      alignItems: "center",
                      fontSize: "16px",
                      fontWeight: "300",
                      color: colors?.text?.black300,
                      backgroundColor: "#fff",
                      fontFamily: colors?.font?.primary,
                      cursor: "pointer",
                    }),
                    singleValue: (base) => ({
                      ...base,
                      fontSize: "16px",
                      fontWeight: "300",
                      letterSpacing: "0.35px",
                      color: colors?.text?.black200,
                      fontFamily: colors?.font?.primary,
                    }),
                    noOptionsMessage: (base) => ({
                      ...base,
                      fontSize: "16px",
                      fontWeight: "300",
                      letterSpacing: "0.35px",
                      color: colors?.text?.black200,
                      fontFamily: colors?.font?.primary,
                    }),
                  }}
                  aria-label="Select Store"
                />
              </SelectionWrapper>
            </Row>
            <Row>
              <Label>Description *</Label>
              <Textarea
                maxLength={250}
                value={description}
                placeholder={"Description"}
                onChange={(e) => setDescription(e?.target?.value)}
                style={{flex: "1", fontFamily: colors?.font?.primary}}
              />
            </Row>

            {/* <FileInputContainer>
              <label
                style={{
                  color: "black",
                  cursor: "pointer",
                  alignItems: "center",
                  fontSize: "14px",
                }}
              >
                <span style={{ marginRight: "8px" }}>📎</span>
                <span style={{ marginRight: "5px" }}>Attach a file</span>
                <FileInput
                  multiple
                  allowedExt={imageExt}
                  setFile={(f) =>
                    setGalleryImages((o) => [...(o || []), ...Array.from(f)])
                  }
                  styles={{ ...customStyles, display: "none", border: "none" }}
                  handleFeaturethumbnail={handleGalleryImages}
                  limit={maxImageDimensions?.variantImage?.limit}
                />
              </label>
            </FileInputContainer>

            {galleryImageList?.length > 0 ? (
              <ImageDisplayContainer>
                {galleryImageList?.map((image, i) => (
                  <ImageDisplayWrapper>
                    <ImageDisplay
                      ref={(el) =>
                        (galleryImagesRef.current[i] = { image, img: el })
                      }
                      src={
                        image?.type?.includes("video")
                          ? VideoIcon
                          : URL.createObjectURL(image)
                      }
                    />
                    <RemoveImage
                      onClick={() => removeGalleryImage(i)}
                    ></RemoveImage>
                  </ImageDisplayWrapper>
                ))}
              </ImageDisplayContainer>
            ) : null} */}
          </FormContainer>
        </ContentContainer>
        <DrawerFooterWrapper>
          <ButtonWithLoading
            isLoading={submitIsLoading}
            disabled={isSubmitDisabled()}
            onClick={() => handleCreateTicket()}
            buttonLabel="Submit"
          />
        </DrawerFooterWrapper>
      </Wrapper>
      {showConfirmation && confirmationPopup()}
    </>
  );
};

const Wrapper = styled.div`
  width: 100%;
`;
const ContentContainer = styled.div`
  width: 100%;
  position: relative;
  padding: 24px;

  @media ${device.laptop} {
    padding: 42px 160px;
  }
`;
const CloseIconContainer = styled.div`
  position: absolute;
  top: 24px;
  right: 24px;
`;
const CloseIcon = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;
const Title = styled.div`
  font-size: 24px;
  line-height: 28px;
  color: ${colors?.text?.black200};
`;
const SubTitle = styled.div`
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.01px;
  color: ${colors?.text?.black200};
  padding-top: 12px;
`;

const FormContainer = styled.div`
  margin-top: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const CustomTextField = styled.input`
  margin-top: 10px;
  display: flex;
  width: 100%;
  height: 36px;
  min-height: 36px;
  font-size: 16px;
  text-align: start;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  text-transform: none;
  outline: none;
  color: ${colors?.text?.black300};
  background-color: #ffffff;
  padding: 0px 20px;

  @media ${device.laptop} {
    width: 78%;
  }
`;
const Textarea = styled.textarea`
  padding: 12px 20px;
  margin-top: 5px;
  display: flex;
  width: 100%;
  height: 160px;
  min-height: 160px;
  font-size: 12pt;
  text-align: start;
  border: 1px solid #e9e9e9;
  border-radius: 10pt;
  text-transform: none;
  background-color: #fff;
  color: ${colors?.text?.black300};
  outline: none;
  margin-top: 10px;

  @media ${device.laptop} {
    width: 78%;
    height: 120px;
    min-height: 120px;
  }
`;
const RaiseIssueTitleContainer = styled.div`
  width: 100%;
  height: 54px;
  position: relative;
`;
const FileInputContainer = styled.div`
  width: 100%;
  height: 54px;
`;
const ImageDisplayContainer = styled.div`
  display: flex;
  width: 100%;
  overflow: auto;
  margin: 0% 0 0 0%;
  justify-content: flex-start;
  border: none;
  border-radius: 4px;
  padding: 16px;
`;
const ImageDisplayWrapper = styled.div`
  position: relative;
  z-index: 999;
  display: flex;
  width: auto;
  justify-content: flex-start;
`;
const ImageDisplay = styled.img`
  width: 75px;
  height: 75px;
`;
const RemoveImage = styled.div`
  display: flex;
  background-image: url(data:image/png;base64,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);
  background-repeat: no-repeat;
  width: 8px;
  height: 15px;
  cursor: pointer;
  align-self: flex-start;
  position: relative;
  right: 5%;
  bottom: 10%;
  padding: 14px;
`;

const DrawerContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

const DrawerFooterWrapper = styled.div`
  width: 100%;
  height: 68px;
  padding: 0px 24px 24px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  bottom: 0px;
  margin: 0 auto;

  @media ${device.laptop} {
    width: 20%;
    padding: 0px 42px 42px 42px;
    border-radius: 0px 0px 20px 20px;
    justify-content: center;
  }
`;

const ModalContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;
const ModalContentContainer = styled.div`
  width: 100%;
  height: 100%;
`;
const SelectionWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 36px;
  margin-top: 10px;
`;
const Label = styled.div`
  flex: 0 0 30%;
  width: 100%;
  font-family: ${colors?.font?.primary};

  @media ${device.laptop} {
    width: 220px;
    margin-right: 10px;
  }
`;
const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  flex-direction: column;

  @media ${device.laptop} {
    flex-direction: row;
  }
`;

const ConfirmationContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 24px;
  box-sizing: border-box;
`;

const TitleWrapper = styled.div`
  background: white;
  padding: 24px;
  border-radius: 8px;
  width: 100%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const ConfirmationTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 12px;
  text-align: center;
  color: ${colors?.text?.black800};
`;

const ConfirmationSubTitle = styled.div`
  font-size: 14px;
  color: ${colors?.text?.black800};
  text-align: center;
`;

const ConfirmationMailImage = styled.img`
  width: 120px;
  height: 120px;
  margin: 0 auto 16px;
  display: block;

  @media ${device.laptop} {
    width: 150px;
    height: 150px;
  }
`;

const DrawerContentContainer = styled.div`
  width: 100%;
  padding: 21px 24px 24px 24px;
  height: calc(100% - 40px - 53px - 20px);
`;

export default ReportIssueModal;
